<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="rounded-lg pa-4">
      <div class="d-flex align-center mb-4">
        <v-avatar size="48" class="section-icon mr-3" rounded>
          <v-icon color="white">mdi-earth</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-1 font-weight-bold primary--text">Custom Domain Settings</div>
          <div class="text-caption grey--text">Connect your own domain name to your school website</div>
        </div>
      </div>

      <v-text-field
        v-model="customDomain"
        label="Enter your custom domain (e.g. www.myschool.edu.ng)"
        outlined
        prepend-inner-icon="mdi-link-variant"
      />

      <div class="d-flex flex-wrap" style="gap: 12px;">
        <v-btn color="primary" rounded elevation="2" class="font-weight-bold text-none" @click="saveDomain" :loading="saving">
          <v-icon left>mdi-content-save-outline</v-icon>
          Save Domain
        </v-btn>
        <v-btn outlined rounded color="primary" class="font-weight-bold text-none" @click="checkStatus" :loading="checking">
          <v-icon left>mdi-dns-outline</v-icon>
          Check DNS Status
        </v-btn>
      </div>

      <div v-if="status" class="mt-4">
        <v-alert v-if="status.verified" type="success" text border="left">
          Domain verified via {{ status.type }} record
        </v-alert>
        <v-alert v-else type="warning" text border="left">
          Domain not verified yet.
        </v-alert>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  props: ['websiteId'],
  data() {
    return {
      customDomain: '',
      status: null,
      saving: false,
      checking: false,
    };
  },
  methods: {
    async saveDomain() {
      this.saving = true;
      try {
        await axios.post(`/api/websites/${this.websiteId}/custom-domain`, {
          domain: this.customDomain
        });
        this.$toast.success('Domain saved. Now verify DNS.');
      } catch (e) {
        this.$toast.error('Failed to save domain.');
      } finally {
        this.saving = false;
      }
    },
    async checkStatus() {
      this.checking = true;
      try {
        const res = await axios.get(`/api/websites/${this.websiteId}/custom-domain`);
        this.status = res.data;
      } catch (e) {
        this.$toast.error('DNS status check failed.');
      } finally {
        this.checking = false;
      }
    }
  }
};
</script>

<style scoped>
.section-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
</style>
